<!-- 注册 -->
<template>
  <div>
    <!-- pc -->
    <div class="loginin hidden-xs hidden-sm hidden-md">
      <img class="loginin_bg" src="@/assets/images/login/login_logo2.png" alt="" />
      <public-input :BtnStatus="BtnStatus" :time="countDownTime" v-for="(item, idx) in login_ipt_arr" :key="idx"
        :ipt_obj="item"></public-input>
      <div @click="signin_func" class="btn_group p_text_center p_hand font_18 color_ffffff bg_DC000C border_radius6">
        {{ $t('login.signup') }}</div>
      <div @click="$router.push('/login')" class="hint p_hand font_12 color_8F8F8F p_text_center">
        {{ $t('login.gosignin') }}
        <span class="color_DC000C">{{ $t('login.signin') }}</span>
      </div>
    </div>
    <!-- h5 -->
    <div class="loginin_h5 hidden-lg">
      <img class="loginin_bg_h5" src="@/assets/images/login/login_logo2.png" alt="" />
      <public-input :BtnStatus="BtnStatus" :time="countDownTime" type="h5" v-for="(item, idx) in login_ipt_arr"
        :key="idx" :ipt_obj="item"></public-input>
      <div @click="signin_func" class="btn_group_h5 p_text_center p_hand font_18 color_ffffff bg_DC000C border_radius6">
        {{ $t('login.signup') }}</div>
      <div @click="$router.push('/login')" class="hint p_hand font_12 color_8F8F8F p_text_center">
        {{ $t('login.gosignin') }}
        <span class="color_DC000C">{{ $t('login.signin') }}</span>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    login_loginup,
    login_getcode
  } from '@/network/index.js';
  import {
    mapGetters
  } from 'vuex'
  export default {
    data() {
      return {
        login_ipt_arr: [{
            label: this.$t('login.email'),
            value: '',
            error: '',
            callback: e => {
              if (e) {
                this.login_ipt_arr[0].value = e;
                this.login_ipt_arr[0].error = '';
                this.login_ipt_arr[1].isclick = true;
              } else {
                this.login_ipt_arr[0].error = `${this.login_ipt_arr[0].label} is null`;
                this.login_ipt_arr[1].isclick = false;
              }
            }
          },
          {
            label: this.$t('login.code'),
            value: '',
            error: '',
            button: this.$t('login.sendcode'),
            isclick: false,
            buttonClick: e => {
              this.validateBtn();
            },
            callback: e => {
              if (e) {
                this.login_ipt_arr[1].value = e;
                this.login_ipt_arr[1].error = '';
              } else {
                this.login_ipt_arr[1].error = `${this.login_ipt_arr[1].label} is null`;
              }
            }
          },
          {
            label: this.$t('login.password'),
            value: '',
            error: '',
            callback: e => {
              if (e) {
                this.login_ipt_arr[2].value = e;
                this.login_ipt_arr[2].error = '';
              } else {
                this.login_ipt_arr[2].error = `${this.login_ipt_arr[2].label} is null`;
              }
            }
          }
        ],
        BtnStatus: true, //btn的状态
        countDownTime: 60, //获取验证码倒计时
        emailID: localStorage.getItem('emailID') ? localStorage.getItem('emailID') : ''
      };
    },
    components: {},
    created() {
      let myEndTime = localStorage.getItem('myEndTime');
      myEndTime && this.codeCountDown(myEndTime);
    },
    mounted() {},
    computed: {
		...mapGetters('setting', ['GET_LANG2'])
	},
    methods: {
      signin_func() {
        let arr = [...this.login_ipt_arr];
        arr.forEach(item => {
          if (!item.value) {
            item.error = `${item.label} is null`;
          }
        });
        this.login_ipt_arr = [...arr];
        this.login_api();
      },
      login_api() {
        //登录接口
        let that = this,
          email = this.login_ipt_arr[0].value,
          emailCode = this.login_ipt_arr[1].value,
          password = this.login_ipt_arr[2].value,
          emailID = this.emailID;
        if (!email || !emailCode || !password || !emailID) {
          return;
        }
        const loading = this.$loading({
          fullscreen: true
        });
        login_loginup({
          email,
          password,
          emailID,
          emailCode,
        }).then(res => {
          if (res.code === '0') {
            let token = res.data.token;
            let user_obj = JSON.stringify(res.data);
            that.$store.commit('login/SET_USER', user_obj);
            that.$store.commit('login/SET_TOKEN', token);
            // 判断是否有上一级页面，如果没有就跳转首页
            that.is_loading = false;
            if (that.$route.query.redirect) {
              that.$router.replace({
                path: that.$route.query.redirect
              });
            } else {
              that.$router.replace({
                path: '/'
              });
            }
          }
          loading.close();
        });
        //=============
        setTimeout(() => {
          loading.close();
        }, 1000);
      }, //end login_api
      // 点击的时候利用本地存储存时间
      validateBtn() {
        //调用获取验证码的接口
        const loading = this.$loading({
          fullscreen: true
        });
        login_getcode({
          email: this.login_ipt_arr[0].value,
          region:this.GET_LANG2
        }).then(res => {
          if (res.code === '0') {
            loading.close();
            this.emailID = res.data;
            localStorage.setItem('emailID', res.data);
            let endMsRes = new Date().getTime() + 60000; //当前时间戳加上一分钟的时间戳，相当于当前时间一分钟以后的时间戳
            localStorage.setItem('myEndTime', JSON.stringify(endMsRes)); // 把这个一分钟时候的事件戳存起来
            this.codeCountDown(endMsRes); // 调用封装的方法
          }
        });
        setTimeout(() => {
          loading.close();
        }, 4000);
      },
      codeCountDown(endMsRes) {
        this.BtnStatus = false;
        this.countDownTime = Math.ceil((endMsRes - new Date().getTime()) / 1000); //剩余多少秒
        let time = setTimeout(() => {
          this.countDownTime--;
          if (this.countDownTime < 1) {
            this.BtnStatus = true;
            this.countDownTime = 60;
            localStorage.removeItem('myEndTime');
            clearTimeout(time);
          } else {
            this.codeCountDown(endMsRes);
          }
        }, 1000);
      }
    }
  };
</script>

<style scoped="scoped">
  .loginin_bg {
    display: block;
    width: 210px;
    height: 210px;
    margin: 0 auto 60px auto;
  }

  .btn_group {
    width: 390px;
    height: 60px;
    line-height: 60px;
    margin: 30px 0 25px 0;
  }

  .hint {
    padding: 5px 0;
  }

  /*  */
  .loginin_bg_h5 {
    width: 180px;
    height: 180px;
  }

  .loginin_bg_h5 {
    display: block;
    width: 180px;
    height: 180px;
    margin: 0 auto 60px auto;
  }

  .btn_group_h5 {
    width: 315px;
    height: 50px;
    line-height: 50px;
    margin: 0px 0 25px 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/login/children/register.vue